import React from 'react'

import PageSectionHeader from '../../../../features/components/PageSectionHeader'
import OnsiteAdsList from './OnsiteAdsList'

const OnsiteRightAds = () => {
  return (
    <>
      <PageSectionHeader title="List of Ads" />
      <OnsiteAdsList />
    </>
  )
}

export default OnsiteRightAds
